// Studio pricing stores balances as millicredits (1000 = 1 credit). Shared
// conversion + thresholds so Plans UI and builder-chat gates stay aligned with
// the finalized catalog ($0.50 peg).

export const MILLICREDITS_PER_CREDIT = 1000;

// Warn in builder chat when remaining credits fall below this (PRD "Builder
// chat" — ~half an average app at the $0.50 peg).
export const LOW_BUILD_CREDITS_THRESHOLD = 20;

export const millicreditsToCredits = (millicredits: number): number =>
  millicredits / MILLICREDITS_PER_CREDIT;

/** Credits render with at most one decimal per the Plans-page rounding rule. */
export const formatCredits = (credits: number): string =>
  credits.toLocaleString(undefined, { maximumFractionDigits: 1 });
